import { Grid, Typography } from "@mui/material";
import _ from "lodash";
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from "react";
import { displayToast } from "../../../framework/toast/toastUtils";
import GlobalContext from "../../../framework/GlobalContext";
import Shortcut from "../../../framework/Shortcut";
import NumberInput from "../../../framework/NumberInput";
import ChipInputSelect from "../../../framework/ChipInputSelect";
import Button from "../../../framework/Button";
import { fetchBranches } from "../../../services/branch-service";
import { bulkUpdateMedicines } from "../../../services/medicine-services";
import { formStateHandler } from "../../../utils/utils";
import classes from "./Update.module.css";
import { MAX_ALLOWABLE_DISCOUNT } from "../../../utils/constant";
import Checkbox from "../../../framework/Checkbox";
import { listBranchGroup } from "../../../services/branch-group-services";
import SelectInput from "../../../framework/SelectInput";
import { gstValues, medicineScheduleTypes } from "../../../utils/constant";
import { searchHsn } from "../../../services/hsn-services";
import TextInput from "../../../framework/TextInput";
import { useSelector } from "react-redux";

const UpdateProduct = ({
  productData,
  onEscape = () => {},
  onSave = () => {},
}) => {
  const [formState, setFormState] = useState({
    allowDiscount: true,
  });
  const [branches, setBranches] = useState([]);
  const [hsnOptions, setHsnOptions] = useState([]);
  const [isLoose, setIsLoose] = useState(false);
  const [isChronic, setIsChronic] = useState(false);
  const [isTb, setIsTb] = useState(false);

  const branchRef = useRef("");
  const updateRef = useRef("");
  const stdDiscountRef = useRef("");
  const maxDiscountRef = useRef("");
  const minStockRef = useRef("");
  const maxStockRef = useRef("");
  const hsnCodeRef = useRef("");
  const gstRef = useRef("");

  const { setCurrentComponent } = useContext(GlobalContext);

  const fetchAllBranches = useCallback(async () => {
    try {
      const _branch = await fetchBranches();
      const _branchGroup = await listBranchGroup();
      const mergedBranches = [
        ...(_branchGroup?.result?.rows || []),
        ...(_branch?.result?.rows || []),
      ];

      setBranches(mergedBranches || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  }, []);

  const validateForm = useCallback(async (fieldName, data) => {
    if (fieldName === "stdDiscount" || !fieldName) {
      if (
        data?.stdDiscount &&
        data?.maxDiscount &&
        data?.stdDiscount > data?.maxDiscount
      ) {
        displayToast({
          type: "error",
          title: "Std Discount cannot be greater than Max Discount",
        });
      }
    }
    if (fieldName === "maxDiscount" || !fieldName) {
      if (
        data?.maxDiscount &&
        data?.stdDiscount &&
        data?.maxDiscount < data?.stdDiscount
      ) {
        displayToast({
          type: "error",
          title: "Max Discount cannot be less than Std Discount",
        });
      }
    }
    // if (fieldName === "maxStock" || !fieldName) {
    //   if (data?.maxStock && data?.minStock && data?.minStock > data?.maxStock) {
    //     displayToast({
    //       type: "error",
    //       title: "Max Stock cannot be less than Min Stock",
    //     });
    //     maxStockRef.current.focus();
    //     return false;
    //   }
    // }

    // if (fieldName === "minStock" || !fieldName) {
    //   if (data?.maxStock && data?.minStock && data?.minStock > data?.maxStock) {
    //     displayToast({
    //       type: "error",
    //       title: "Min Stock cannot be greater than Max Stock.",
    //     });
    //     return false;
    //   }
    //   maxStockRef.current.focus();
    // }

    if (!fieldName || fieldName === "add_update_details_minstock") {
      if (
        (data?.minStock < 1 && data?.minStock !== null) ||
        (!data?.minStock && data?.maxStock)
      ) {
        displayToast({
          type: "error",
          title: "Please enter a Min stock value greater than Zero.",
        });
        minStockRef.current.focus();
        return false;
      }
    }

    if (!fieldName || fieldName === "add_update_details_maxStock") {
      if (
        (data?.maxStock < 1 && data?.maxStock != null) ||
        (data?.minStock && !data?.maxStock)
      ) {
        displayToast({
          type: "error",
          title: "Please enter a Max stock value greater than Zero.",
        });
        maxStockRef.current.focus();
        return false;
      }
    }

    if (fieldName === "branch" || !fieldName) {
      if (!data?.branch || data?.branch?.length === 0) {
        displayToast({
          type: "error",
          title: "Please select at least one Branch",
        });
        branchRef.current.focus();
        return false;
      }
    }
    return true;
  }, []);

  const handleFormChange = useCallback(
    (
      fieldName,
      fieldValue,
      isSelect = false,
      options = [],
      sendOption = false
    ) => {
      const updatedFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options,
        sendOption
      );
      setFormState(updatedFormState);
    },
    [formState]
  );

  const saveFormHandler = async () => {
    if (!(await validateForm(null, formState))) return;

    const selectedBranchIds = formState?.branch?.reduce((acc, branch) => {
      if (branch?.branchCode) {
        acc.push(...branch.branchCode);
      } else if (branch?.code) {
        acc.push(branch.code);
      }
      return acc;
    }, []);
    const uniqueBranchIds = [...new Set(selectedBranchIds)];
    const branchMetaData = uniqueBranchIds?.reduce((acc, selectedBranch) => {
      acc[selectedBranch] = {
        maxDiscount: formState?.maxDiscount,
        minStock: formState?.minStock,
        maxStock: formState?.maxStock,
        discPer: formState?.discPer,
        isLoose: formState?.isLoose,
        isChronic: formState?.isChronic,
        tcsPer: formState?.tcsPer,
        istb: formState?.isTb,
        rack: formState?.rack,
        rack1: formState?.rack1,
        hsnCode: formState?.hsnCode,
        gccess: formState?.gccess,
        vat: formState?.vat,
        boxMrp: formState?.boxMrp,
        boxPtr: formState?.boxPtr,
        markup: formState?.markup,
        passiveMrp: formState?.passiveMrp,
        passiveCp: formState?.passiveCp,
        autoOrderDays: formState?.autoOrderDays,
        rateItemwise: formState?.rateItemwise,
        minDays: formState?.minDays,
        maxDays: formState?.maxDays,
        computeMinMax: formState?.computeMinMax,
        medicineGstPer: formState?.gst?.id === "" ? null : formState?.gst?.id,
        genericId: formState?.scheduleType?.id
          ? formState?.scheduleType?.id
          : undefined,
        isBanned: formState?.isBanned,
        isReturnable: formState?.isReturnable,
        isDiscontinued: formState?.isDiscontinued,
        isUndeliverable: formState?.isUndeliverable,
        isActive: formState?.isActive,
        disableAutoBarcode: formState?.disableAutoBarcode,
        skipFromApo: formState?.skipFromApo,
        skipFromShortBook: formState?.skipFromShortBook,
        blockExpiryPrint: formState?.blockExpiryPrint,
        disableAutoBarcodePrinting: formState?.disableAutoBarcodePrinting,
        allowDiscount: formState?.allowDiscount,
        allowWeb: formState?.allowWeb,
        b2BOffset: formState?.b2BOffset,
        b2bSellingPrice: formState?.b2bSellingPrice,
        b2bForceSellingPrice: formState?.b2bForceSellingPrice,
        dpPercentage: formState?.dpPercentage,
        sellingPrice: formState?.sellingPrice,
      };
      return acc;
    }, {});

    let medicinesArray = productData.map((medicine) => ({
      ...medicine,
      branchMetaData: branchMetaData,
    }));

    const payload = {
      medicines: medicinesArray,
    };

    await bulkUpdateMedicines(payload)
      .then((response) => {
        if (response.status !== "success") {
          displayToast({
            type: "error",
            title: response,
          });
          return;
        }
        displayToast({
          type: "success",
          title: "Product updated successfully",
        });
        onSave(response.result);
      })
      .catch(() => {});
  };

  const debounceAndSave = _.debounce(saveFormHandler, 300);

  const escapeHandler = useCallback(() => {
    onEscape();
  }, [onEscape]);

  const keyupListener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      if (key === "escape") {
        escapeHandler();
        return;
      }
      if (e.ctrlKey && key === "s") {
        return updateRef.current.click();
      }
    },
    [escapeHandler]
  );

  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener]);

  useEffect(() => {
    if (!formState) return;
    setIsLoose(formState?.isLoose);
    setIsChronic(formState?.isChronic);
    setIsTb(formState?.isTb);
  }, [formState]);

  useEffect(() => {
    fetchAllBranches();
  }, [fetchAllBranches]);

  return (
    <div className={classes["update-product-container"]}>
      <Typography variant="h6" className={classes["update-product-header"]}>
        Update Details
      </Typography>
      <Grid container spacing={2} className={classes["update-product-grid"]}>
        <Grid item xs={2}>
          <SelectInput
            id="add_product_gst"
            name="medicineGstPer"
            value={formState?.gst}
            label="GST"
            ref={gstRef}
            autoFocus={true}
            onFocus={() => setCurrentComponent("add_product_gst")}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label;
            }}
            onBlur={(e) => {
              validateForm("add_product_gst", formState);
            }}
            onChange={(event, option) => {
              //removeErrorStateOnChange("add_product_gst");
              handleFormChange("gst", option);
            }}
            getOptionLabel={(option) => {
              return option.label;
            }}
            options={gstValues}
            markers={JSON.stringify({
              up: "add_product_gst",
              down: "add_product_is_chronic",
              left: "add_product_gst",
              right: "add_product_schedule_type",
            })}
            //error={checkErrorStateExists("add_product_gst", errorState)}
            // required
          />
        </Grid>
        <Grid item xs={2}>
          <SelectInput
            id="add_product_schedule_type"
            name="scheduledId"
            value={formState?.scheduleType}
            label="Schedule Type"
            onFocus={() => setCurrentComponent("add_product_schedule_type")}
            onBlur={(e) => {
              validateForm("add_product_schedule_type", formState);
            }}
            onChange={(event, option) => {
              // removeErrorStateOnChange("add_product_schedule_type");
              handleFormChange("scheduleType", option);
            }}
            // disabled={isAddRecipe}
            options={medicineScheduleTypes}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label;
            }}
            markers={JSON.stringify({
              up: "add_product_type",
              down: "add_product_tb",
              left: "add_product_gst",
              right: "add_product_hsn_code",
            })}
            // error={checkErrorStateExists(
            //   "add_product_schedule_type",
            //   errorState
            // )}
            // required
          />
        </Grid>
        <Grid item xs={2}>
          <SelectInput
            id="add_product_hsn_code"
            name="hsnCode"
            value={formState?.hsnCode || ""}
            label="HSN Code"
            inputRef={hsnCodeRef}
            disableClearable={false}
            noOptionsText={"Search HSN code"}
            onFocus={() => setCurrentComponent("add_product_hsn_code")}
            onBlur={() => validateForm("add_product_hsn_code", formState)}
            onInputChange={(e, newValue) => {
              if (!newValue) return;
              if (isNaN(newValue)) {
                return;
              }
              //removeErrorStateOnChange("add_product_hsn_code");
              handleFormChange("hsnCode", newValue);
              if (newValue.length >= 3) {
                searchHsn(`search=${newValue.trim()}`).then((resp) => {
                  const updatedResp = resp
                    .filter((prod) => prod?.hsnCodeId && prod?.hsnCode)
                    .map((prod) => ({
                      id: prod.hsnCodeId,
                      label: prod.hsnCode,
                    }));
                  setHsnOptions(updatedResp);
                });
              } else {
                setHsnOptions([]);
              }
            }}
            onChange={(event, option) => {
              if (option) {
                const selectedValue = option.label;
                handleFormChange("hsnCode", selectedValue);
              } else {
                handleFormChange("hsnCode", "");
              }
            }}
            options={hsnOptions}
            getOptionLabel={(option) => {
              if (!option) return "";
              return option.label || option;
            }}
            isOptionEqualToValue={(option, value) => option === value}
            markers={JSON.stringify({
              up: "add_product_packaging",
              down: "add_product_sub_therapeutic",
              left: "add_product_schedule_type",
              right: "add_product_rack",
            })}
            // error={checkErrorStateExists("add_product_hsn_code", errorState)}
            // required
          />
        </Grid>
        <Grid item xs={2}>
          <TextInput
            id="add_product_rack"
            name="rack"
            label="Rack1"
            value={formState?.rack}
            onFocus={() => setCurrentComponent("add_product_rack")}
            onChange={(e) => {
              handleFormChange("rack", e.target.value.toUpperCase());
            }}
            maxInputLength={2000}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_qty_per_unit",
                down: "add_product_disc_per",
                left: "add_product_hsn_code",
                right: "add_product_rack1",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextInput
            id="add_product_rack1"
            name="rack1"
            label="Rack2"
            value={formState?.rack1}
            onFocus={() => setCurrentComponent("add_product_rack1")}
            onChange={(e) => {
              handleFormChange("rack1", e.target.value.toUpperCase());
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_outer_qty",
                down: "add_product_max_disc",
                left: "add_product_rack",
                right: "add_product_isLoose",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_isLoose"
            name="isLoose"
            label="Is Loose"
            checked={isLoose}
            onFocus={() => setCurrentComponent("add_product_isLoose")}
            onChange={(e) => {
              handleFormChange("isLoose", e.target.checked);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                down: "add_product_compounds",
                left: "add_product_rack1",
                up: "add_product_rack1",
                right: "add_product_is_chronic",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_is_chronic"
            name="chronic"
            label="Chronic"
            checked={isChronic}
            onChange={(e) => {
              handleFormChange("isChronic", e.target.checked);
            }}
            onFocus={() => setCurrentComponent("add_product_is_chronic")}
            inputProps={{
              "data-markers": JSON.stringify({
                down: "add_product_gccess",
                left: "add_product_isLoose",
                up: "add_product_rack1",
                right: "add_product_tb",
              }),
            }}
          />
        </Grid>

        <Grid item xs={2}>
          <Checkbox
            id="add_product_tb"
            name="isTb"
            label="Is TB"
            checked={isTb}
            onChange={(e) => {
              handleFormChange("isTb", e.target.checked);
            }}
            onFocus={() => setCurrentComponent("add_product_tb")}
            inputProps={{
              "data-markers": JSON.stringify({
                down: "add_product_vat",
                left: "add_product_is_chronic",
                up: "add_product_barcode",
                right: "add_product_allow_discount",
              }),
            }}
          />
        </Grid>
        

        <Grid item xs={2}>
          <Checkbox
            id="add_product_allow_discount"
            label="Allow Discounts"
            checked={formState?.allowDiscount}
            onChange={(e) => {
              handleFormChange("allowDiscount", e.target.checked);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_allow_discount");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                down: "add_product_box_ptr",
                left: "add_product_tb",
                up: "add_product_allow_discount",
                right: formState?.allowDiscount
                  ? "add_product_disc_per"
                  : "add_product_tcs",
              }),
            }}
          />
        </Grid>

        {formState?.allowDiscount && (
          <Grid item xs={2}>
            <NumberInput
              id="add_product_disc_per"
              name="addProductDiscPer"
              label="Discount %"
              onFocus={() => {
                setCurrentComponent("add_product_disc_per");
              }}
              value={formState?.discPer}
              onChange={(e) => {
                handleFormChange("discPer", +e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_disc_per",
                  down: "add_product_gccess",
                  right: "add_product_max_disc",
                  left: "add_product_allow_discount",
                }),
              }}
            />
          </Grid>
        )}
        {formState?.allowDiscount && (
          <Grid item xs={2}>
            <NumberInput
              id="add_product_max_disc"
              name="addProductMaxDisc"
              label="Max Discount%"
              onFocus={() => {
                setCurrentComponent("add_product_max_disc");
              }}
              value={formState?.maxDiscount}
              onChange={(e) => {
                handleFormChange("maxDiscount", +e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_max_disc",
                  down: "add_product_vat",
                  right: "add_product_tcs",
                  left: "add_product_disc_per",
                }),
              }}
            />
          </Grid>
        )}

        <Grid item xs={2}>
          <NumberInput
            id="add_product_tcs"
            name="addProductTcs"
            label="TCS %"
            onFocus={() => {
              setCurrentComponent("add_product_tcs");
            }}
            value={formState?.tcsPer}
            onChange={(e) => {
              handleFormChange("tcsPer", +e.target.value);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_allow_discount",
                down: "add_product_box_ptr",
                right: "add_product_gccess",
                left: "add_product_max_disc",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_gccess"
            name="addProductGccess"
            label="GCCESS %"
            value={formState?.gccess}
            onChange={(e) => {
              handleFormChange("gccess", +e.target.value);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_gccess");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_disc_per",
                down: "add_product_selling_price",
                left: "add_product_tcs",
                right: "add_product_vat",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_vat"
            name="addProductVat"
            label="VAT %"
            value={formState?.vat}
            onChange={(e) => {
              handleFormChange("vat", +e.target.value);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_vat");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_max_disc",
                down: "add_product_passive_cp",
                left: "add_product_gccess",
                right: "add_product_box_ptr",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_box_ptr"
            label="Box PTR ₹"
            decimalScale={2}
            value={formState?.boxPtr}
            onChange={(e) => {
              handleFormChange("boxPtr", +e.target.value);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_box_ptr");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_vat",
                right: "add_product_box_mrp",
                down: "add_product_rate_itemwise",
                up: "add_product_tcs",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_box_mrp"
            label="Box MRP ₹"
            decimalScale={2}
            value={formState?.boxMrp}
            onChange={(e) => {
              handleFormChange("boxMrp", +e.target.value);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_box_mrp");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_box_ptr",
                right: "add_product_mrp",
                down: "add_product_rate_itemwise",
                up: "add_product_gccess",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_mrp"
            label="MRP ₹"
            value={formState?.passiveMrp}
            onValueChange={(value) => {
              handleFormChange("passiveMrp", value?.floatValue);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_mrp");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_box_mrp",
                right: "add_product_markup",
                up: "add_product_vat",
                down: "add_product_auto_order_days",
              }),
            }}
          />
        </Grid>

        <Grid item xs={2}>
          <NumberInput
            id="add_product_markup"
            name="addProductMarkup"
            label="Markup Price ₹"
            value={formState?.markup}
            onValueChange={(value) => {
              handleFormChange("markup", value?.floatValue);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_markup");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_mrp",
                right: "add_product_selling_price",
                down: "add_product_enable_min_max_computation_for_apo",
                up: "add_product_vat",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_selling_price"
            name="addProductSellingPrice"
            label="Selling Price ₹"
            value={formState?.sellingPrice}
            onValueChange={(value) => {
              handleFormChange("sellingPrice", value?.floatValue);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_selling_price");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_markup",
                right: "add_product_passive_cp",
                down: "add_product_enable_min_max_computation_for_apo",
                up: "add_product_vat",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_passive_cp"
            name="addProductPassiveCp"
            label="Cost Price ₹"
            value={formState?.passiveCp}
            onValueChange={(value) => {
              handleFormChange("passiveCp", value?.floatValue);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_passive_cp");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_selling_price",
                right: "add_product_rate_itemwise",
                down: "add_product_disable_auto_barcode",
                up: "add_product_box_ptr",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_rate_itemwise"
            label="Rate Itemwise"
            checked={formState?.rateItemwise}
            onChange={(e) => {
              handleFormChange("rateItemwise", e.target.checked);
            }}
            onFocus={() => {
              setCurrentComponent("add_product_rate_itemwise");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                left: "add_product_passive_cp",
                right: "add_product_min_stock",
                down: "add_product_min_order_days",
                up: "add_product_box_mrp",
              }),
            }}
          />
        </Grid>

        <Grid item xs={2}>
          <NumberInput
            id="add_product_min_stock"
            name="addProductMinStock"
            label="Min Stock"
            ref={minStockRef}
            value={formState?.minStock}
            decimalScale={0}
            onChange={(e) => {
              if (!e.target.value) {
                handleFormChange("minStock", null);
                return;
              }
              handleFormChange("minStock", +e.target.value);
              //removeErrorStateOnChange("add_product_min_stock");
            }}
            onFocus={() => {
              setCurrentComponent("add_product_min_stock");
            }}
            onBlur={() => {
              validateForm("add_product_min_stock", formState);
            }}
            // error={checkErrorStateExists(
            //   "add_product_min_stock",
            //   errorState
            // )}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_passive_cp",
                down: "add_product_min_order_days",
                left: "add_product_rate_itemwise",
                right: "add_product_max_stock",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_max_stock"
            name="addProductMaxStock"
            label="Max Stock"
            ref={maxStockRef}
            value={formState?.maxStock}
            decimalScale={0}
            onChange={(e) => {
              if (!e.target.value) {
                handleFormChange("maxStock", null);
                return;
              }
              handleFormChange("maxStock", +e.target.value);
              //removeErrorStateOnChange("add_product_max_stock");
            }}
            onFocus={() => {
              setCurrentComponent("add_product_max_stock");
            }}
            onBlur={() => {
              validateForm("add_product_max_stock", formState);
            }}
            // error={checkErrorStateExists(
            //   "add_product_max_stock",
            //   errorState
            // )}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_rate_itemwise",
                down: "add_product_max_order_days",
                left: "add_product_min_stock",
                right: "add_product_auto_order_days",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_auto_order_days"
            label="Auto order days"
            name="addProductAutoOrderDays"
            decimalScale={0}
            value={formState?.autoOrderDays}
            onChange={(e) => {
              if (!e.target.value) {
                handleFormChange("autoOrderDays", null);
                return;
              }
              handleFormChange("autoOrderDays", +e.target.value);
              //removeErrorStateOnChange("add_product_auto_order_days");
            }}
            onFocus={() => {
              setCurrentComponent("add_product_auto_order_days");
            }}
            // error={checkErrorStateExists(
            //   "add_product_auto_order_days",
            //   errorState
            // )}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_mrp",
                down: "add_product_auto_order_days",
                right: "add_product_enable_min_max_computation_for_apo",
                left: "add_product_max_stock",
              }),
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <Checkbox
            id="add_product_enable_min_max_computation_for_apo"
            label="Enable min-max computation for APO"
            name="computeMinMax"
            onChange={(e) => {
              handleFormChange("computeMinMax", e.target.checked);
            }}
            checked={formState?.computeMinMax}
            onFocus={() => {
              setCurrentComponent(
                "add_product_enable_min_max_computation_for_apo"
              );
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_markup",
                down: "add_product_b2b_force_selling_price",
                left: "add_product_auto_order_days",
                right: "add_product_min_order_days",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_min_order_days"
            label="Min Days"
            name="addProductminDays"
            decimalScale={0}
            onChange={(e) => {
              if (!e.target.value) {
                handleFormChange("minDays", null);
                return;
              }
              handleFormChange("minDays", +e.target.value);
              //removeErrorStateOnChange("add_product_min_order_days");
            }}
            value={formState?.minDays}
            onFocus={() => {
              setCurrentComponent("add_product_min_order_days");
            }}
            onBlur={() => {
              validateForm("add_product_min_order_days", formState);
            }}
            // error={checkErrorStateExists(
            //   "add_product_min_order_days",
            //   errorState
            // )}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_min_stock",
                down: "add_product_is_banned",
                right: "add_product_max_order_days",
                left: "add_product_enable_min_max_computation_for_apo",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_max_order_days"
            label="Max Days"
            name="addProductmaxDays"
            decimalScale={0}
            value={formState?.maxDays}
            onChange={(e) => {
              if (!e.target.value) {
                handleFormChange("maxDays", null);
                return;
              }
              handleFormChange("maxDays", +e.target.value);
              //removeErrorStateOnChange("add_product_max_order_days");
            }}
            onFocus={() => {
              setCurrentComponent("add_product_max_order_days");
            }}
            onBlur={() => {
              validateForm("add_product_max_order_days", formState);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_max_stock",
                down: "add_product_max_order_days",
                right: "add_product_sales_b2b_markup_per",
                left: "add_product_min_order_days",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_sales_b2b_markup_per"
            name="b2BOffset"
            label="B2B Markup %"
            onFocus={() => {
              setCurrentComponent("add_product_sales_b2b_markup_per");
            }}
            value={formState?.b2BOffset}
            decimalScale={2}
            onValueChange={(value) => {
              handleFormChange("b2BOffset", value?.floatValue);
            }}
            // disabled={
            //   formState?.b2bForceSellingPrice || formState?.b2bSellingPrice
            // }
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_auto_order_days",
                down: "add_product_sales_b2b_markup_per",
                right: "add_product_sales_b2b_selling_price",
                left: "add_product_max_order_days",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_sales_b2b_selling_price"
            name="b2bSellingPrice"
            label="B2B Selling Price ₹"
            onFocus={() => {
              setCurrentComponent("add_product_sales_b2b_selling_price");
            }}
            value={formState?.b2bSellingPrice}
            decimalScale={2}
            // disabled={formState?.b2BOffset}
            onValueChange={(value) => {
              handleFormChange("b2bSellingPrice", value?.floatValue);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_gccess",
                down: "add_product_enable_min_max_computation_for_apo",
                right: "add_product_b2b_force_selling_price",
                left: "add_product_sales_b2b_markup_per",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_b2b_force_selling_price"
            label="B2B Force Selling Price"
            name="b2bForceSellingPrice"
            onChange={(e) => {
              handleFormChange("b2bForceSellingPrice", e.target.checked);
            }}
            checked={formState?.b2bForceSellingPrice || false}
            onFocus={() => {
              setCurrentComponent("add_product_b2b_force_selling_price");
            }}
            // disabled={formState?.b2BOffset}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_enable_min_max_computation_for_apo",
                down: "add_product_is_active",
                left: "add_product_sales_b2b_selling_price",
                right: "add_product_dp_percentage",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <NumberInput
            id="add_product_dp_percentage"
            name="dpPercentage"
            label="DP %"
            onFocus={() => {
              setCurrentComponent("add_product_dp_percentage");
            }}
            value={formState?.dpPercentage}
            decimalScale={2}
            onValueChange={(value) => {
              handleFormChange("dpPercentage", value?.floatValue);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_enable_min_max_computation_for_apo",
                down: "add_product_dp_percentage",
                left: "add_product_b2b_force_selling_price",
                right: "add_product_is_banned",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_is_banned"
            name="addProdductIsBanned"
            label="Lock PO/Purchase"
            onChange={(e) => {
              handleFormChange("isBanned", e.target.checked);
            }}
            checked={formState?.isBanned}
            onFocus={() => {
              setCurrentComponent("add_product_is_banned");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_min_order_days",
                down: "add_product_skip_from_apo",
                left: "add_product_dp_percentage",
                right: "add_product_is_returnable",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_is_returnable"
            name="addProductIsReturnable"
            label="Is Returnable"
            onChange={(e) => {
              handleFormChange("isReturnable", e.target.checked);
            }}
            checked={formState?.isReturnable}
            onFocus={() => {
              setCurrentComponent("add_product_is_returnable");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_is_returnable",
                down: "add_product_allow_on_web",
                left: "add_product_is_banned",
                right: "add_product_locked",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_locked"
            name="addProductLocked"
            label="Lock"
            onChange={(e) => {
              handleFormChange("isDiscontinued", e.target.checked);
            }}
            checked={formState?.isDiscontinued}
            onFocus={() => {
              setCurrentComponent("add_product_locked");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_locked",
                down: "add_product_storage",
                left: "add_product_is_returnable",
                right: "add_product_is_undeliverable",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_is_undeliverable"
            name="addProductIsUndeliverable"
            label="Is Undeliverable"
            onChange={(e) => {
              handleFormChange("isUndeliverable", e.target.checked);
            }}
            checked={formState?.isUndeliverable}
            onFocus={() => {
              setCurrentComponent("add_product_is_undeliverable");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_is_undeliverable",
                down: "add_product_storage",
                left: "add_product_locked",
                right: "add_product_is_active",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_is_active"
            name="addProductIsActive"
            label="Is Active"
            onChange={(e) => {
              handleFormChange("isActive", e.target.checked);
            }}
            checked={formState?.isActive}
            onFocus={() => {
              setCurrentComponent("add_product_is_active");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_is_active",
                down: "add_update_details_branch",
                left: "add_product_is_undeliverable",
                right: "add_product_disable_auto_barcode",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_disable_auto_barcode"
            name="addProductDisableAutoBarcode"
            label="Disable Auto Barcode"
            onChange={(e) => {
              handleFormChange("disableAutoBarcodePrinting", e.target.checked);
            }}
            checked={formState?.disableAutoBarcodePrinting}
            onFocus={() => {
              setCurrentComponent("add_product_disable_auto_barcode");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_disable_auto_barcode",
                down: "add_update_details_branch",
                left: "add_product_is_active",
                right: "add_product_skip_from_apo",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_skip_from_apo"
            name="addProductSkipFromAPO"
            label="Skip from APO"
            onChange={(e) => {
              handleFormChange("skipFromApo", e.target.checked);
            }}
            checked={formState?.skipFromApo}
            onFocus={() => {
              setCurrentComponent("add_product_skip_from_apo");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_skip_from_apo",
                down: "add_update_details_branch",
                left: "add_product_disable_auto_barcode",
                right: "add_product_skip_from_short_book",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_skip_from_short_book"
            name="addProductSkipFromShortBook"
            label="Skip from Short Book"
            onChange={(e) => {
              handleFormChange("skipFromShortBook", e.target.checked);
            }}
            checked={formState?.skipFromShortBook}
            onFocus={() => {
              setCurrentComponent("add_product_skip_from_short_book");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_is_banned",
                down: "add_update_details_branch",
                left: "add_product_skip_from_apo",
                right: "add_product_block_expiry_print",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            label="Block Expiry Print"
            id="add_product_block_expiry_print"
            name="addProductBlockExpiryPrint"
            onChange={(e) => {
              handleFormChange("blockExpiryPrint", e.target.checked);
            }}
            checked={formState?.blockExpiryPrint}
            onFocus={() => {
              setCurrentComponent("add_product_block_expiry_print");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_is_banned",
                down: "add_update_details_branch",
                left: "add_product_skip_from_short_book",
                right: "add_product_allow_on_web",
              }),
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Checkbox
            id="add_product_allow_on_web"
            label="Allow on Web"
            name="addProductAllowOnWeb"
            onChange={(e) => {
              handleFormChange("allowWeb", e.target.checked);
            }}
            checked={formState?.allowWeb}
            onFocus={() => {
              setCurrentComponent("add_product_allow_on_web");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "add_product_is_returnable",
                down: "add_update_details_branch",
                left: "add_product_block_expiry_print",
                right: "add_update_details_branch",
              }),
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            marginTop: "30px",
          }}
        >
          <ChipInputSelect
            id="add_update_details_branch"
            value={formState?.branch || []}
            options={branches}
            groupBy={(option) => (option?.code ? "Branches" : "Branch Group")}
            name="branch"
            required={true}
            ref={branchRef}
            getOptionLabel={(option) =>
              `${option?.name || ""}- ${option?.code ? "BR" : "BG"}`
            }
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            onFocus={() => setCurrentComponent("add_update_details_branch")}
            onChange={(event, option) => handleFormChange("branch", option)}
            openOnFocus={true}
            label="Branches"
            multiple={true}
            blurOnSelect={false}
            disableCloseOnSelect={true}
            renderGroup={(params) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    padding: "5px",
                    gap: "5px",
                  }}
                  key={params.key}
                >
                  <div
                    style={{
                      height: "30px",
                      width: "100%",
                      background: "#e0e0e0",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    {params.group}
                  </div>
                  <div>{params.children}</div>
                </div>
              );
            }}
            renderOption={(props, option, { selected }) => {
              return (
                <div
                  {...props}
                  style={{
                    display: "flex",
                    height: "40px",
                    width: "100%",
                    padding: "1px 5px",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItem: "center",
                    }}
                  >
                    <Checkbox checked={selected} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItem: "center",
                      marginRight: "5px",
                    }}
                  >
                    {option?.branchGroupId ? "BG |" : "BR |"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItem: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "15px",
                        width: "100%",
                      }}
                    >
                      {option?.name} ({option?.code || option?.branchGroupId})
                    </div>
                  </div>
                </div>
              );
            }}
            markers={JSON.stringify({
              up: "add_product_allow_on_web",
              left: "add_product_allow_on_web",
              right: "add_update_details_branch",
              down: "add_update_details_branch",
            })}
          />
        </Grid>
      </Grid>

      <div className={classes["update-product-button-container"]}>
        <Button
          label="Save"
          color="violet"
          ref={updateRef}
          endIcon={<Shortcut keys={["Ctrl", "S"]} />}
          onClick={debounceAndSave}
        />
      </div>
    </div>
  );
};

export default UpdateProduct;
